import React, { useState, useEffect, useCallback, useReducer } from "react";
import { useParams, useLocation } from "react-router-dom";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Badge,
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Input,
// } from "reactstrap";
import {Card,Row,Col,Badge,Button,Modal} from "react-bootstrap";

import Spinner from "components/Loader/Spinner";
// import Switch from "react-bootstrap-switch";
import Form from 'react-bootstrap/Form';
import ReadAloud from "components/Question/Speaking/New/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/New/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/New/RepeatSentece.jsx";
import RetellLec from "components/Question/Speaking/New/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/New/ShortQue.jsx";
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder1.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Reading/WrittingBlank.jsx";
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import ShowHistory from "views/ShowHistory.jsx";
import ShowHistoryData from "views/ShowHistoryData.jsx";
import ChromeCheck from "views/ChromeCheck.jsx";
import QuestionComment from "views/QuestionComment.jsx";
import UserNotes from "views/UserNotes.jsx";
import ReactHtmlParser from "react-html-parser";
import API, { s3base } from "api.js";
import { store } from "store/index";
import { setAlert, expVidPopup } from "action/index.js";
import { setUser } from "action/index.js";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";

import TooltipItem from "components/ToolTip/ToolTipItem.jsx";
import SpeakingResult from "components/Result/SpeakingResult.jsx";
import WritingResult from "components/Result/WritingResult.jsx";
import ReadingResult from "components/Result/ReadingResult.jsx";
import ListeningResult from "components/Result/ListeningResult.jsx";

import TokenFinished from "components/PracticeMaterial/PopUps/TokensFinished";
import ExplanationPopUp from "components/PracticeMaterial/PopUps/ExplanationPopUp";
import ExplanationVidPopUp from "components/PracticeMaterial/PopUps/ExplanationVidPopup";
import ModalSkeleton from "components/PopUps/ModalSkeleton";
import LoaderDumb from "components/Loader/LoaderDumb.jsx";
import WordDefinitionModal from "components/PracticeMaterial/PopUps/WordDefinitionModal";
import TranslateModal from "components/PracticeMaterial/PopUps/TranslateModal";
import ListenAudio from "components/PracticeMaterial/PopUps/ListenAudio";
import SidebarClose from "components/Sidebar/SidebarClose";

import QuestionAudioAlternative from "components/Question/QuestionAudioAlternative";
import Result from "components/Question/Result/Result";
import ResultPopup from "components/Question/Result/ResultPopup";
import ConfirmAction from "components/Dashboard/Popup/ConfirmAction";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import PracticePageHeader from "components/PracticeMaterial/New/PracticePageHeader";
import MoreAiSuggestions from "components/Result/More/MoreAiSuggestions";
import QuestionResponses from "components/PracticeMaterial/QuestionResponses/QuestionResponses.jsx";
import TestedPopup from "components/PracticeMaterial/PopUps/Tested";
import ReportPopup from "components/PracticeMaterial/PopUps/Report";
import QuestionExplanationVideo from "components/PopUps/QuestionExplanationVideo";
import SummarizeGroupDiscussion from "components/Question/Speaking/New/SummarizeGroupDiscussion";
import RespondToSituation from "components/Question/Speaking/New/RespondToSituation";

const mapStateToProps = (state) => {
  return {
    user: state.user,
    expVidPopup: state.expVidPopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
    setExpVidPopup: (count) => dispatch(expVidPopup(count)),
  };
};

const speaking = [1, 2, 3, 4, 5, 13];
const writing = [6, 7];
const TRANSLATE_BUTTON_SUBCATEGORIES = [1, 2, 4, 11, 13, 16];
const SAMPLE_RESPONSE_BUTTON_SUBCATEGORIES = [1, 11];
const SHOW_RESULT_POPUP = [1, 2, 3, 4, 5, 6, 7, 13, 20,21,22];
const TAGS = ["grey", "red", "green", "yellow"];
const AUDIO_TRANSCRIPT = [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20, 22];

const PracticeHistory = (props) => {
  const params = useParams();
  const location = useLocation();

  const [state, setState] = useState({
    questionData: [],
    currentQuestion: 0,
    isRecording: false,
    blobURL: "",
    error: "",
    history: [],
    board: [],
    historyData: [],
    history_flag: false,
    isBlocked: false,
    is_answer: false,
    is_result: false,
    resultObj: {
      text_answer: "",
      length: 0,
      type: params?.id || "1",
      answer: "",
      script: "",
      q_ans: "",
      correct: "",
      strategy: 1,
    },
    resultData: "",
    process: false,
    testModal: false,
    textAr: false,
    comment_process: false,
    modal: false,
    switched: false,
    reportText: "",
    history_process: false,
    historyMore: false,
    boardMore: false,
    restart: false,
    type: params?.id || "1",
    prediction: params?.type || "all",
    aType: params?.aType || "all",
    mark: params?.mark || "all",
    atmptd: params?.attempted || "all",
    complexity: params?.complexity || "all",
    submitFlag: false,
    attempted: 0,
    intervalId1: "",
    secondCount1: 0,
    note_flag: false,
    board_process: false,
    all_ok: true,
    hideNav: false,
    user: props.user,
    isSubscribed: props.user.active_subscription.length > 0 ? true : false,
    viewVideo: false,
    viewHindiVideo: false,
    videoModal: false,
    videoModalState: false,
    videoHindiModal: false,
    videoHindiModalState: false,
    videoUrl: "",
    videoHindiUrl: "",
    thirtyDaysInMs: "",
    timeDiffInMs: "",
    attemptedQuestions: [],
    isAttempted: false,
    orderby: localStorage.getItem("orderby")
      ? localStorage.getItem("orderby")
      : "desc",
    isSubscribedCheck: props.subscribed ? props.subscribed : "false",
    total_questions: 0,
    open_ques: 1,
    search_string: "",
    user_text: null,
    connected: true,
    backOnline: false,
    ping_server: null,
    questionsList: [],
    currentQues: null,
    fail: undefined,
    new_html: null,
    new_result: null,
    tokens: [],
    currTokens: null,
    tokensPopUp: false,
    explanationPopUp: false,
    expVid: null,
    loader: false,
    nextBtnVid: false,
    showBottomExplanationPopup: false,
    scriptLanguages: [],
    voices: [],
    modalDestroy: true,
    wordDefinitionModalIsOpen: false,
    selectedWord: "",
    translateModal: false,
    sampleResponseModal: false,
    option_explaination: "",
    resultPopup: false,
    dropdownOpen: false,
    confirmRestart: false,
    playingAudioFromTrascriptButton: false,
    //from here i added the new states for the better U
  loading: true,
  prevButtonLoading: false,
  nextButtonLoading: false,
  isNavigatingToNextQue: false,
  mainAudioPlaying: true,
  soundStatusMain: true,
  isStopped: false,
  retryError: false,
  retryMessage: "",
  retryIndex: null,
  retryType: null,
  resultPopupData: {},
  allData: {},
  explanationModal: false,
  html: null,
   refreshHistory: false,
   attemptedTimes: 0,
   confirmRestartProcessing: false,
  });

  // const updateState = (newState) => {
  //   setState((prevState) => ({ ...prevState, ...newState }));
  // };

  const updateState = useCallback((updater) => {
  if (typeof updater === "function") {
    setState((prevState) => {
      const result = updater(prevState);
      return { ...prevState, ...result };
    });
  } else {
    setState((prevState) => ({ ...prevState, ...updater }));
  }
}, []);

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const toggleDropDown = () => {
    updateState({
      dropdownOpen: !state.dropdownOpen,
    });
  };

  const toggle = (tab) => {
    if (state.activeTab !== tab) {
      updateState({ activeTab: tab });
    }
  };

  const restartQue = useCallback(() => {
    updateState({ restart: false, secondCount1: 0 });
  }, [updateState]);

  const setRestart = useCallback(() => {
    updateState({ restart: false, secondCount1: 0 });
  }, [updateState]);

  const setIsStopped = useCallback(() => {
    updateState({ isStopped: false });
  }, [updateState]);

  const updateQuestionAudioUrl = useCallback((url) => {
    updateState({
      questionAudioUrl: url,
    });
  }, [updateState]);

  const stayConnected = () => {
    const ping_server = setInterval(() => {
      API({
        url: "https://la-ping.languageacademy.com.au/connected",
        method: "GET",
      });
    }, 5000);
    updateState({ ping_server });
  };

  // useEffect(() => {
  //   console.log("The exp video popup : ",props.expVidPopup)
  //   const mountLogic = async () => {
  //     if (location?.state?.questions) {
  //       const questions = location.state.questions.map((val, index) => {
  //         return { id: val.question.id, index: index };
  //       });
  //       updateState({
  //         questionsList: questions,
  //         currentQues: location.state.index,
  //       });
  //     }

  //     if (
  //       Intl.DateTimeFormat().resolvedOptions().timeZone === "Australia/Sydney"
  //     ) {
  //       stayConnected();
  //     }

  //     let localStorage_orderby = localStorage.getItem("orderby");
  //     if (!localStorage_orderby) {
  //       localStorage.setItem("orderby", "desc");
  //     }

  //     let urlParams = new URLSearchParams(window.location.search);
  //     let myParam = urlParams.get("view");
  //     let hideNav = parseInt(myParam) === 1 ? true : false;
  //     let open_ques = parseInt(urlParams.get("page"))
  //       ? parseInt(urlParams.get("page"))
  //       : 0;
  //     let q_id = params?.index || 0;

  //     updateState({ hideNav: hideNav, open_ques });

  //     let { type, prediction, aType, mark, atmptd, complexity, orderby } =
  //       state;

  //     const ques = await loadQuestion(open_ques, q_id);
  //     console.log(open_ques);
  //     console.log("ques.................", ques);

  //     if (ques.status === 200) {
  //       const expVid = ques?.data?.expVid;
  //       let intervalId1 = setInterval(timer1, 1000);
  //       let question_data = ques?.data?.data[0];
  //       console.log("question_data.................", question_data);

  //       const token = speaking.includes(question_data?.subcategory_id)
  //         ? ques.data.tokens.speaking
  //         : writing.includes(question_data?.subcategory_id)
  //         ? ques.data.tokens.writing
  //         : null;

  //       updateState({
  //         currTokens: token,
  //         questionData: ques.data.data,
  //         tokens: ques.data.tokens,
  //         tag: question_data?.tag?.length > 0 ? question_data?.tag[0]?.tag : "grey",
  //         intervalId1: intervalId1,
  //         currentQuestion: open_ques,
  //         total_questions: ques.data.total,
  //         testCount: ques?.data?.data[0]?.tested,
  //         expVid,
  //         scriptLanguages: ques?.data?.script_languages,
  //         audio_script: ques?.data?.data[0]?.audio_script,
  //         voices: ques?.data?.voices,
  //       });

  //       let { currentQuestion, questionData, user } = state;
  //       let { video, hindi_video, created_at } = questionData[0] || {};

  //       const pastTime = new Date(created_at);
  //       const now = new Date();
  //       const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
  //       const timeDiffInMs = now.getTime() - pastTime.getTime();

  //       if (ques.data.total !== 0 && open_ques > 0) {
  //         document.querySelector(".selectPage").value = currentQuestion;
  //       }

  //       let attempted_questions = [];
  //       if (
  //         user.user_attempted_questions !== null &&
  //         user.user_attempted_questions !== undefined
  //       ) {
  //         attempted_questions =
  //           user.user_attempted_questions.attempted_questions;
  //       }

  //       const obj =
  //         attempted_questions.length > 0
  //           ? JSON.parse(attempted_questions)
  //           : attempted_questions;
  //       const questions_id = obj?.questions_id || [];

  //       updateState({
  //         videoUrl: video !== null ? video : null,
  //         viewVideo: video !== null ? true : false,
  //         videoHindiUrl: hindi_video !== null ? hindi_video : null,
  //         viewHindiVideo: hindi_video !== null ? true : false,
  //         thirtyDaysInMs,
  //         timeDiffInMs,
  //         attemptedQuestions: questions_id,
  //       });

  //       // FIXED: Added missing function call
  //       loadAttemptedQuestiondata(ques?.data?.data[0]?.id);
  //     } else {
  //       store.dispatch(
  //         setAlert({
  //           flag: true,
  //           type: 2,
  //           message: "Something went wrong. Unable to load question.",
  //         })
  //       );
  //     }
  //   };

  //   mountLogic();
  // }, []);
  
  useEffect(() => {
  const mountLogic = async () => {
    try {
      updateState({ loading: true, error: null });

      if (location?.state?.questions) {
        const questions = location.state.questions.map((val, index) => {
          return { id: val.question.id, index: index };
        });
        updateState({
          questionsList: questions,
          currentQues: location.state.index,
        });
      }

      stayConnected();

      let localStorage_orderby = localStorage.getItem("orderby");
      if (!localStorage_orderby) {
        localStorage.setItem("orderby", "desc");
      }

      let urlParams = new URLSearchParams(window.location.search);
      let hideNav = parseInt(urlParams.get("view")) === 1 ? true : false;
      let q_id = params?.index || 0;

      updateState({ hideNav });

      const ques = await loadQuestion(0, q_id);

      if (ques.status === 200) {
        const expVid = ques?.data?.expVid;
        let intervalId1 = setInterval(timer1, 1000);
        let question_data = ques?.data?.data[0];

        const token = speaking.includes(question_data?.subcategory_id)
          ? ques.data.tokens.speaking
          : writing.includes(question_data?.subcategory_id)
          ? ques.data.tokens.writing
          : null;

        updateState({
          currTokens: token,
          questionData: ques.data.data,
          tokens: ques.data.tokens,
          tag: question_data?.tag?.length > 0 ? question_data?.tag[0]?.tag : "grey",
          intervalId1: intervalId1,
          currentQuestion: 0,
          total_questions: ques.data.total,
          testCount: ques?.data?.data[0]?.tested,
          expVid,
          scriptLanguages: ques?.data?.script_languages,
          audio_script: ques?.data?.data[0]?.audio_script,
          voices: ques?.data?.voices,
          loading: false,
          attemptedTimes: question_data.attempted.length,
          mainAudioPlaying: true
        });

        let { video, hindi_video, created_at } = question_data;

        const pastTime = new Date(created_at);
        const now = new Date();
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        const timeDiffInMs = now.getTime() - pastTime.getTime();

        updateState({
          videoUrl: video !== null ? video : null,
          viewVideo: video !== null ? true : false,
          videoHindiUrl: hindi_video !== null ? hindi_video : null,
          viewHindiVideo: hindi_video !== null ? true : false,
          thirtyDaysInMs,
          timeDiffInMs,
        });

        loadAttemptedQuestiondata(question_data.id);
      } else {
        throw new Error("Failed to load question");
      }
    } catch (error) {
      console.error("Error loading question:", error);
      updateState({
        loading: false,
        error: "Error loading question data.",
      });
      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Something went wrong. Unable to load question.",
        })
      );
    }
  };

  mountLogic();
}, []);

  useEffect(() => {
  updateState({
    isAttempted: state.attemptedTimes > 0 ? true : false
  });
}, [state.attemptedTimes]);

 const loadQuestion = async (ques, q_id = null) => {
    let localStorage_orderby = localStorage.getItem("orderby");
    if (!localStorage_orderby) {
      localStorage.setItem("orderby", "desc");
    }

    let urlParams = new URLSearchParams(window.location.search);
    let hideNav = parseInt(urlParams.get("view")) === 1 ? true : false;

    let { type, prediction, aType, mark, atmptd, complexity, orderby } = state;
    complexity = complexity.split("?")[0];
    let search_string =
      urlParams.get("search") === "" || urlParams.get("search") === null
        ? ""
        : urlParams.get("search");
    return await API({
      method: "GET",
      url: `question/${type}?prediction=${prediction}&type=${aType}&mark=${mark}&attempted=${atmptd}&complexity=${complexity}&orderby=${orderby}&practice=${!hideNav}&open_ques=${ques}&qid=${q_id}&search=${search_string}`,
    });
  };

  const loadQuestiondata = () => {
    API({
      method: "GET",
      url: "question/",
    })
      .then((data) => {
        updateState({ questionData: data.data.data });
      })
      .catch(() => {});
  };
  
const updateAttemptedState = useCallback(() => {
  updateState(prev => ({
    ...prev,
    attemptedTimes: prev.attemptedTimes - 1
  }));
}, []);

  const loadAttemptedQuestiondata = (currentQuestionId) => {
    const { user_attempted_questions } = store.getState().user;
    let attemptedQuestions = [];
    if (
      user_attempted_questions !== null &&
      user_attempted_questions !== undefined
    ) {
      const aq = user_attempted_questions.attempted_questions;
      if (aq && aq.length > 0) {
        try {
          const obj = typeof aq === "string" ? JSON.parse(aq) : aq;
          attemptedQuestions = obj?.questions_id || [];
        } catch (e) {
          console.error("Error parsing attempted_questions:", e);
          attemptedQuestions = [];
        }
      }
    }
    const question_id = currentQuestionId?.toString();
    const checkquestionid = attemptedQuestions.includes(question_id);
    updateState({ isAttempted: checkquestionid });
  };

  // useEffect(() => {
  //   return () => {
  //     if (state.intervalId1) clearInterval(state.intervalId1);
  //     if (state.ping_server) clearInterval(state.ping_server);
  //   };
  // }, []);

  useEffect(() => {
  // Stop any existing timer first
  if (state.intervalId1) {
    clearInterval(state.intervalId1);
  }

  // Start timer only if not in result mode
  const id = setInterval(() => {
    updateState((prev) => ({ secondCount1: prev.secondCount1 + 1 }));
  }, 1000);

  updateState({ intervalId1: id });

  return () => clearInterval(id); // cleanup on unmount
}, [state.currentQuestion, state.restart]);

const fetchQuestionFromList = useCallback(
  async (direction) => {
    // direction: 'next' or 'prev'
    const { currentQues, questionsList } = state;
    
    const currentIndex = questionsList.findIndex(
      (obj) => obj.index === currentQues
    );
    
    if (currentIndex === -1) {
      throw new Error("Current question not found in list");
    }
    
    const targetIndex = direction === 'next' 
      ? currentIndex + 1 
      : currentIndex - 1;
    
    if (targetIndex < 0 || targetIndex >= questionsList.length) {
      throw new Error("No more questions in that direction");
    }
    
    const targetQuestion = questionsList[targetIndex];
    
    const res = await loadQuestion(0, targetQuestion.id);
    
    if (!res || res.status !== 200 || !res.data?.data?.length) {
      throw new Error("Failed to load question");
    }
    
    return {
      data: res.data.data,
      newIndex: targetQuestion.index,
      questionData: res.data.data[0]
    };
  },
  [state.currentQues, state.questionsList]
);

  const changeReportText = (e) => {
    let { name, value } = e.target;
    updateState({ [name]: value });
  };

  const submitReport = () => {
    if (state.reportText === "") {
      store.dispatch(
        setAlert({ flag: true, type: 2, message: "Message cant't be empty" })
      );
      return "";
    }

    let bodyFormData = new FormData();
    bodyFormData.set("text", state.reportText);
    bodyFormData.set("question_id", state.questionData[0].id);
    API({
      method: "POST",
      data: bodyFormData,
      url: "report/question",
    })
      .then((data) => {
        if (data.status === 200) {
          updateState({ reportText: "", modal: false });
          store.dispatch(
            setAlert({ flag: true, type: 1, message: data.data.message })
          );
        }
      })
      .catch(() => {});
  };

    const nextButtonVidPopup = (status, showVid = false) => {
    // console.log("This is Status : ",status , "The is showVid : ", showVid)
    if (!showVid) {
      // console.log("Inside the showVide : ",!showVid , "Status : ", status);
      updateState({ nextBtnVid: status });
      if (!status) {
        props.setExpVidPopup(10);
      }
    } else {
      updateState({ nextBtnVid: status });
    }
  };

  // const nextButton = async (manual = false) => {

  //   // if (!manual) {
  //   //   if (props.expVidPopup === 0) {
  //   //     nextButtonVidPopup(true);
  //   //     return;
  //   //   }
  //   // }
  //   if (state.intervalId1) {
  //       clearInterval(state.intervalId1);
  //     }

  //   updateState({
  //     option_explaination: "" ,
  //     is_answer: false,
  //     user_text: null,
  //     fail: undefined,
  //     new_html: null,
  //     new_result: null,
  //     submitFlag: false,
  //     // i added  these state 
  //      secondCount1: 0,
  //       intervalId1: null,
  //       mainAudioPlaying: true,
  //       isStopped: false,
  //       soundStatusMain: false,
  //       playingAudioFromTrascriptButton: false,
  //       switched: false,
  //       nextButtonLoading: true,
  //       isNavigatingToNextQue: true,
  //       retryError: false,
  //       retryMessage: ""
  //   });

  //   let { currentQuestion, currentQues, questionsList } = state;
  //   let nextQue =
  //     questionsList[
  //       questionsList.findIndex((obj) => obj.index === currentQues) + 1
  //     ];

  //   let new_ques = await loadQuestion(0, nextQue.id);

  //   if (
  //     new_ques.status === 200 &&
  //     new_ques.data.data &&
  //     new_ques.data.data.length > 0
  //   ) {
  //     updateState({ currentQues: nextQue.index });
  //     let question_data = new_ques.data.data[0];
  //     let { tag, tested, video, hindi_video, created_at } = question_data;

  //     let now = new Date();
  //     let pastTime = new Date(created_at);
  //     let thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
  //     let timeDiffInMs = now.getTime() - pastTime.getTime();

  //     updateState({
  //       comment: [],
  //       board: [],
  //       history: [],
  //       process: false,
  //       currentQuestion: currentQuestion + 1,
  //       tag: tag && tag.length > 0 ? tag[0].tag : "grey",
  //       is_answer: false,
  //       is_result: false,
  //       history_flag: false,
  //       comment_flag: false,
  //       secondCount1: 0,
  //       testCount: tested || 0,
  //       board_flag: false,
  //       note_flag: false,
  //       viewVideo: video !== null ? true : false,
  //       videoUrl: video !== null ? video : null,
  //       viewHindiVideo: hindi_video !== null ? true : false,
  //       videoHindiUrl: hindi_video !== null ? hindi_video : null,
  //       thirtyDaysInMs,
  //       timeDiffInMs,
  //       questionData: new_ques.data.data,
  //     });

  //     loadAttemptedQuestiondata(question_data.id);
  //   } else {
  //     store.dispatch(
  //       setAlert({
  //         flag: true,
  //         type: 2,
  //         message: "Something went wrong. Unable to load question.",
  //       })
  //     );
  //   }
  // };
  
  const nextButton = useCallback(
  async (manual = false) => {
    try {
      // Clear interval
      if (state.intervalId1) {
        clearInterval(state.intervalId1);
      }

      // Reset states
      updateState({
        option_explaination: "",
        is_answer: false,
        user_text: null,
        fail: undefined,
        new_html: null,
        new_result: null,
        submitFlag: false,
        secondCount1: 0,
        intervalId1: null,
        mainAudioPlaying: true,
        isStopped: false,
        soundStatusMain: false,
        playingAudioFromTrascriptButton: false,
        switched: false,
        nextButtonLoading: true,
        isNavigatingToNextQue: true,
        retryError: false,
        retryMessage: ""
      });

      await new Promise(resolve => setTimeout(resolve, 150));

      // Check video popup logic
      // if (!manual && props.expVidPopup > 0) {
      //   nextButtonVidPopup(true);
      //   updateState({ nextButtonLoading: false });
      //   return;
      // }

      // Fetch next question
      const result = await fetchQuestionFromList('next');
      const question_data = result.questionData;

      const {
        tag,
        tested,
        video,
        hindi_video,
        created_at,
        isVideo,
        isHindiVideo,
        attempted
      } = question_data;

      const now = new Date();
      const pastTime = new Date(created_at);
      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
      const timeDiffInMs = now.getTime() - pastTime.getTime();

      updateState({
        comment: [],
        board: [],
        history: [],
        process: false,
        currentQues: result.newIndex,
        currentQuestion: state.currentQuestion + 1,
        tag: Array.isArray(tag) && tag.length > 0 ? tag[0].tag : "grey",
        is_answer: false,
        is_result: false,
        history_flag: false,
        comment_flag: false,
        secondCount1: 0,
        testCount: tested,
        board_flag: false,
        note_flag: false,
        viewVideo: isVideo,
        viewHindiVideo: isHindiVideo,
        videoUrl: video ?? null,
        videoHindiUrl: hindi_video ?? null,
        thirtyDaysInMs,
        timeDiffInMs,
        questionData: result.data,
        soundStatusMain: true,
        attemptedTimes: attempted?.length ?? 0,
        nextButtonLoading: false,
        submitFlag: false,
        isStopped: false,
        isNavigatingToNextQue: false
      });

      loadAttemptedQuestiondata(question_data.id);

      if (
        props.user.active_subscription.length < 1 ||
        props.user.active_subscription[0].plan.is_gold === 0
      ) {
        props.setExpVidPopup(props.expVidPopup - 1);
      }

    } catch (error) {
      console.error("Next Question Error:", error);

      updateState({
        retryError: true,
        retryType: "next",
        retryMessage: "Unable to load question. Please retry.",
        nextButtonLoading: false,
        isNavigatingToNextQue: false,
      });

      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Unable to load question",
        })
      );
    }
  },
  [
    state.intervalId1,
    state.currentQuestion,
    state.currentQues,
    props.user,
    props.expVidPopup,
    props.setExpVidPopup,
    fetchQuestionFromList,
    loadAttemptedQuestiondata,
    nextButtonVidPopup,
    updateState,
  ]
);

  // const prevButton = async (e) => {
  //   e.preventDefault();
  //   updateState({
  //     is_answer: false,
  //     user_text: null,
  //     fail: undefined,
  //     new_html: null,
  //     new_result: null,
  //     submitFlag: false,
  //     option_explaination: "",
  //   });

  //   let { currentQuestion, currentQues, questionsList } = state;
  //   let prevQue =
  //     questionsList[
  //       questionsList.findIndex((obj) => obj.index === currentQues) - 1
  //     ];

  //   let new_ques = await loadQuestion(0, prevQue.id);

  //   if (
  //     new_ques.status === 200 &&
  //     new_ques.data.data &&
  //     new_ques.data.data.length > 0
  //   ) {
  //     updateState({ currentQues: prevQue.index });
  //     let question_data = new_ques.data.data[0];
  //     let { tag, tested, video, hindi_video, created_at } = question_data;

  //     let pastTime = new Date(created_at);
  //     let now = new Date();
  //     let thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
  //     let timeDiffInMs = now.getTime() - pastTime.getTime();

  //     updateState({
  //       comment: [],
  //       board: [],
  //       history: [],
  //       process: false,
  //       tag: tag && tag.length > 0 ? tag[0].tag : "grey",
  //       currentQuestion: currentQuestion - 1,
  //       is_answer: false,
  //       is_result: false,
  //       history_flag: false,
  //       comment_flag: false,
  //       secondCount1: 0,
  //       testCount: tested || 0,
  //       board_flag: false,
  //       note_flag: false,
  //       viewVideo: video !== null ? true : false,
  //       videoUrl: video !== null ? video : null,
  //       viewHindiVideo: hindi_video !== null ? true : false,
  //       videoHindiUrl: hindi_video !== null ? hindi_video : null,
  //       thirtyDaysInMs,
  //       timeDiffInMs,
  //       questionData: new_ques.data.data,
  //     });

  //     loadAttemptedQuestiondata(question_data.id);
  //   } else {
  //     store.dispatch(
  //       setAlert({
  //         flag: true,
  //         type: 2,
  //         message: "Something went wrong. Unable to load question.",
  //       })
  //     );
  //   }
  // };
  
  const prevButton = useCallback(
  async (e) => {
    e.preventDefault();

    try {
      updateState({
        option_explaination: "",
        is_answer: false,
        user_text: null,
        fail: undefined,
        new_html: null,
        new_result: null,
        submitFlag: false,
        playingAudioFromTrascriptButton: false,
        mainAudioPlaying: true,
        soundStatusMain: false,
        switched: false,
        isStopped: false,
        prevButtonLoading: true,
        isNavigatingToNextQue: true,
        retryError: false,
        retryMessage: ""
      });

      await new Promise(resolve => setTimeout(resolve, 150));

      // Fetch previous question
      const result = await fetchQuestionFromList('prev');
      const question_data = result.questionData;

      if (!question_data) {
        store.dispatch(
          setAlert({
            flag: true,
            type: 2,
            message: "No previous question available.",
          })
        );
        updateState({
          prevButtonLoading: false,
          isNavigatingToNextQue: false
        });
        return;
      }

      const {
        tag = [],
        tested = [],
        video = null,
        hindi_video = null,
        created_at = null,
        isVideo = false,
        isHindiVideo = false,
        attempted
      } = question_data;

      const pastTime = created_at ? new Date(created_at) : new Date();
      const now = new Date();
      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
      const timeDiffInMs = now.getTime() - pastTime.getTime();

      updateState({
        comment: [],
        board: [],
        history: [],
        process: false,
        tag: Array.isArray(tag) && tag.length > 0 ? tag[0].tag : "grey",
        currentQues: result.newIndex,
        currentQuestion: state.currentQuestion - 1,
        is_answer: false,
        is_result: false,
        history_flag: false,
        comment_flag: false,
        secondCount1: 0,
        testCount: tested,
        board_flag: false,
        note_flag: false,
        viewVideo: isVideo,
        videoUrl: video,
        viewHindiVideo: isHindiVideo,
        videoHindiUrl: hindi_video,
        thirtyDaysInMs,
        timeDiffInMs,
        questionData: result.data,
        soundStatusMain: true,
        attemptedTimes: attempted.length,
        prevButtonLoading: false,
        isStopped: false,
        submitFlag: false,
        isNavigatingToNextQue: false
      });

      loadAttemptedQuestiondata(question_data.id);

    } catch (error) {
      console.error("Previous Question Error:", error);

      updateState({
        retryError: true,
        retryType: "prev",
        retryMessage: "Unable to load question. Please retry.",
        prevButtonLoading: false,
        isNavigatingToNextQue: false,
      });

      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Something Went Wrong",
        })
      );
    }
  },
  [
    state.currentQuestion,
    state.currentQues,
    fetchQuestionFromList,
    loadAttemptedQuestiondata,
    updateState,
  ]
);

const retryQuestion = useCallback(async () => {
  try {
    updateState({
      retryError: false,
      questionData: [],
      [state.retryType === 'next' ? 'nextButtonLoading' : 'prevButtonLoading']: true
    });

    const result = await fetchQuestionFromList(state.retryType);

    updateState({
      questionData: result.data,
      currentQues: result.newIndex,
      currentQuestion: state.retryType === 'next' 
        ? state.currentQuestion + 1 
        : state.currentQuestion - 1,
      [state.retryType === 'next' ? 'nextButtonLoading' : 'prevButtonLoading']: false
    });

    loadAttemptedQuestiondata(result.questionData.id);

  } catch (err) {
    updateState({
      retryError: true
    });
    store.dispatch(
      setAlert({
        flag: true,
        type: 2,
        message: "Retry failed. Please check your connection."
      })
    );
    updateState({
      nextButtonLoading: false,
      prevButtonLoading: false
    });
  }
}, [state.retryType, state.currentQuestion, fetchQuestionFromList, loadAttemptedQuestiondata, updateState]);

  const showModal = () => {
    updateState({ modal: !state.modal });
  };

  const submitResponse = (data, f = false) => {
    let qdata = state.questionData[0];
    let obj = {
      data: data.data,
      text_answer: data.answer,
      length: data.length,
      type: qdata.subcategory_id,
      id: qdata.id,
      answer: qdata.question,
      script: qdata.audio_script,
      q_ans: qdata.answer,
      html: qdata.html,
      correct: data.correct,
      lang: data.lang,
      duration: data.duration,
      audio_text: data.audio_text,
      blob_url: data.blob_url,
      strategy: state.resultObj.strategy,
    };
    updateState({
      resultObj: obj,
      submitFlag: f,
      new_html: null,
       blobURL: data.blob_url,
    });
  };

 

  const changeSelectPagination = async (e) => {
    let selectedQuestion = parseInt(e.target.value);
    updateState({
      is_answer: false,
      user_text: null,
      fail: undefined,
      new_html: null,
      new_result: null,
      submitFlag: false,
    });

    let new_ques = await loadQuestion(selectedQuestion);
    if (
      new_ques.status === 200 &&
      new_ques.data.data &&
      new_ques.data.data.length > 0
    ) {
      let question_data = new_ques.data.data[0];
      let checkifSelectPaghasvideo = question_data.video;
      let checkifSelectPaghashindivideo = question_data.hindi_video;

      var pastTime = new Date(question_data.created_at);
      var now = new Date();
      var thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
      var timeDiffInMs = now.getTime() - pastTime.getTime();

      updateState({
        comment: [],
        board: [],
        history: [],
        process: false,
        currentQuestion: selectedQuestion,
        tag:
          question_data.tag && question_data.tag.length > 0
            ? question_data.tag[0].tag
            : "grey",
        is_answer: false,
        is_result: false,
        history_flag: false,
        comment_flag: false,
        note_flag: false,
        secondCount1: 0,
        viewVideo: checkifSelectPaghasvideo !== null ? true : false,
        videoUrl:
          checkifSelectPaghasvideo !== null ? checkifSelectPaghasvideo : null,
        viewHindiVideo: checkifSelectPaghashindivideo !== null ? true : false,
        videoHindiUrl:
          checkifSelectPaghashindivideo !== null
            ? checkifSelectPaghashindivideo
            : null,
        thirtyDaysInMs: thirtyDaysInMs,
        timeDiffInMs: timeDiffInMs,
        questionData: new_ques.data.data,
        option_explaination: "",
      });

      loadAttemptedQuestiondata(question_data.id);
    } else {
      store.dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: "Something went wrong. Unable to load question.",
        })
      );
    }
  };

  // const submitQuestionResponse = async (formData) => {
  //   const url = `submit/practice?random=${Math.floor(
  //     Math.random() * 1000000000
  //   )}`;
  //   return await API({
  //     method: "POST",
  //     url,
  //     data: formData,
  //   });
  // };

  const submitQuestionResponse = useCallback(async (formData) => {
  const url = `submit/practice?random=${Math.floor(
    Math.random() * 1000000000
  )}`;
  const response = await API({
    method: "POST",
    url,
    data: formData,
  });

  // Refresh history data after successful submission
  if (response.status === 200) {
    updateState({ refreshHistory: true });
  }

  return response;
}, [updateState]);

  // const afterSubmitResponseActionOne = (data, state_obj) => {
  //   const {
  //     content,
  //     transcript,
  //     fluency,
  //     pronunciation,
  //     html,
  //     intonation,
  //     fail,
  //     fail_message,
  //     new_html,
  //     average_pace,
  //     total,
  //     new_format,
  //   } = data.data;

  //   if (state.questionData[0].subcategory_id === 5) {
  //     state_obj.resultData = `Content Score : ${content} \n Your Response: ${transcript}`;

  //     let new_array = [JSON.parse(new_html)];
  //     state_obj.new_html = new_array;
  //     state_obj.content_score = content;
  //   } else {
  //     state_obj.resultData = `Content Score : ${content} \n Fluency Score : ${fluency} \n Pronunciation Score : ${pronunciation} \n ${html}`;
  //     state_obj.new_html =
  //       typeof new_html === "string" ? JSON.parse(new_html) : new_html;

  //     state_obj.content_score = content;
  //     state_obj.fluency_score = fluency;
  //     state_obj.pronunciation_score = pronunciation;
  //     state_obj.intonation_score = intonation;
  //     state_obj.average_pace = average_pace;
  //     state_obj.total_score = total;
  //   }

  //   if (fail) {
  //     state_obj.fail = fail_message;
  //   }
  //   state_obj.new_result = new_format;
  //   updateState(state_obj);
  // };
  
  const afterSubmitResponseActionOne = useCallback((data, state_obj) => {
  const responseData = data?.data || {};

  const content = responseData.content?.score || 0;
  const fluency = responseData.fluency?.score || 0;
  const pronunciation = responseData.pronunciation?.score || 0;
  const intonation = responseData.intonation?.score || 0;
  const new_format = responseData.new_format || null;
  const new_html = responseData.new_html || null;
  const score_data = responseData.score_data || [];
  const transcript = responseData.transcript || "";
  const html = responseData.html || "";
  const fail = responseData.fail;
  const fail_message = responseData.fail_message || "";
  const average_pace = responseData.average_pace || 0;
  const total = responseData.total || 0;
  const template_issue = responseData.template_issue;
  const common_sentence = responseData.common_sentence;
  const template_type = responseData.template_type;

  updateState((prevState) => {
    if (prevState.questionData.length === 0) {
      return prevState;
    }
    
    if (prevState.questionData[0].subcategory_id === 5) {
      return {
        ...prevState,
        resultData: `Content Score : ${content} \n Your Response: ${transcript}`,
        new_html: new_html
          ? typeof new_html === "string"
            ? [JSON.parse(new_html)]
            : [new_html]
          : null,
        content_score: content,
        new_result: new_format || null,
        html: html,
        ...state_obj,
      };
    } else {
      const newState = {
        ...prevState,
        resultData: `Content Score : ${content} \n Fluency Score : ${fluency} \n Pronunciation Score : ${pronunciation} \n ${html}`,
        new_html: new_html
          ? typeof new_html === "string"
            ? JSON.parse(new_html)
            : new_html
          : null,
        resultPopupData: {
          content,
          fluency,
          pronunciation,
          intonation,
          average_pace,
          total,
        },
        content_score: content,
        fluency_score: fluency,
        pronunciation_score: pronunciation,
        intonation_score: intonation,
        average_pace,
        total_score: total,
        new_result: new_format || null,
        html: html,
        ...state_obj,
      };

      if ([3, 4].includes(prevState.questionData[0].subcategory_id)) {
        if (["repeat", "common"].includes(template_type)) {
          newState.explanationModal = true;
        }
        newState.score_data = score_data;
        newState.template_issue = template_issue;
        newState.common_sentence = common_sentence;
        newState.template_type = template_type;
        newState.allData = {
          content,
          fluency,
          pronunciation,
          overall: ((content + fluency + pronunciation) / 3).toFixed(0),
        };
      }

      if (fail) {
        newState.fail = fail_message;
      }

      return newState;
    }
  });
}, [updateState]);

  const afterSubmitResponseActionTwo = (data, state_obj) => {
    const {
      content_score,
      form_score,
      grammar_score,
      vocab_score,
      total_s,
      ling_score,
      struct_score,
      error,
      spelling_score,
      new_format,
    } = data.data;

    if (state.questionData[0].subcategory_id === 6) {
      state_obj.resultData = `Content : ${content_score}/2 \n Form : ${form_score}/1 \n Grammar and spellings : ${grammar_score}/2 \n Vocabulary : ${vocab_score}/2 \n Total : ${total_s}/7 \n ${error}`;
    } else {
      state_obj.resultData = `Content : ${content_score}/3 \n Form : ${form_score}/2 \n Grammar : ${grammar_score}/2 \n Vocabulary : ${vocab_score}/2 \n Linguistic range	: ${ling_score}/2 \n Structure : ${struct_score}/2 \n Spelling : ${spelling_score}/2 \n Total : ${total_s}/15 \n ${error}`;
    }

    state_obj.new_result = new_format;
    updateState(state_obj);
  };

  const afterSubmitResponseActionThree = (data, state_obj) => {
    const { score, from, new_format } = data.data;
    state_obj.resultData = `Score : ${score}/${from}`;

    state_obj.new_result = new_format;
    updateState(state_obj);
  };

  const afterSubmitResponseActionFour = (data, state_obj) => {
    const { questionData, currentQuestion } = state;
    const { new_format } = data.data;

    if (questionData[0].subcategory_id === 13) {
      const {
        content_score,
        form_score,
        grammar_score,
        vocab_score,
        spelling_score,
        total_s,
        error,
      } = data.data;
      state_obj.resultData = `Content : ${content_score}/2 \n Form : ${form_score}/2 \n Grammar : ${grammar_score}/2 \n Vocabulary : ${vocab_score}/2 \n Spelling : ${spelling_score}/2 \n Total : ${total_s}/10 \n ${error}`;
    } else if (questionData[0].subcategory_id === 20) {
      const { score, from, html } = data.data;
      state_obj.resultData = `Score : ${score}/${from} \n ${html}`;
    } else {
      const { score, from } = data.data;
      state_obj.resultData = `Score : ${score}/${from}`;
    }

    state_obj.new_result = new_format;
    updateState(state_obj);
  };

  const essayResponse = (data, state_obj) => {
    const {
      content_score,
      form_score,
      grammar_score,
      vocab_score,
      total_s,
      ling_score,
      struct_score,
      error,
      spelling_score,
      new_format,
    } = data.data;
    state_obj.resultData = `Content: ${content_score}/3 \n Form: ${form_score}/2 \n Grammar: ${grammar_score}/2 \n Vocabulary: ${vocab_score}/2 \n Linguistic Range: ${ling_score}/2 \n Structure: ${struct_score}/2 \n Spelling: ${spelling_score}/2 \n Total: ${total_s}/15 \n ${error}`;
    state_obj.new_result = new_format;
    updateState(state_obj);
  };

  // const showResponse = async () => {
  //   updateState({
  //     is_answer: true,
  //     resultData: "",
  //     process: true,
  //     loader: true,
  //   });

  //   let { questionData, resultObj } = state;

  //   var bodyFormData = new FormData();
  //   bodyFormData.set("text", resultObj.answer);
  //   bodyFormData.set("script", resultObj.script);
  //   bodyFormData.set("type", resultObj.type);
  //   bodyFormData.set("id", resultObj.id);
  //   bodyFormData.set("lang", resultObj.lang);
  //   bodyFormData.set("practice", "1");
  //   bodyFormData.set("device", "website");

  //   let t = 0;
  //   if ([1, 2, 3, 4, 5, 21, 22].includes(questionData[0].subcategory_id)) {
  //     bodyFormData.set("answer", resultObj.ans);
  //     bodyFormData.set("text_answer", resultObj.text_answer);
  //     bodyFormData.set("q_ans", resultObj.q_ans);
  //     bodyFormData.set("length", resultObj.length);
  //     bodyFormData.set("file", resultObj.data);
  //     bodyFormData.set("duration", resultObj.duration);
  //     bodyFormData.set("audio_text", resultObj.audio_text);

  //     if (parseInt(questionData[0].subcategory_id) === 1) {
  //       bodyFormData.set("strategy", resultObj.strategy);
  //     }

  //     t = 1;
  //   } else if ([6, 7].includes(questionData[0].subcategory_id)) {
  //     bodyFormData.set("answer", state.resultObj.q_ans);
  //     bodyFormData.set("text_answer", resultObj.text_answer);
  //     bodyFormData.set("length", resultObj.length);

  //     t = 2;
  //   } else if ([8, 9, 10, 11, 12].includes(questionData[0].subcategory_id)) {
  //     bodyFormData.set("selected", resultObj.text_answer);
  //     bodyFormData.set("answer", resultObj.correct);
  //     bodyFormData.set("correct", resultObj.correct);

  //     t = 3;
  //   } else if (
  //     [13, 14, 15, 17, 19, 20, 18, 16].includes(questionData[0].subcategory_id)
  //   ) {
  //     bodyFormData.set("text_answer", resultObj.text_answer);
  //     bodyFormData.set("answer", state.resultObj.correct);
  //     bodyFormData.set("selected", resultObj.text_answer);
  //     bodyFormData.set("correct", resultObj.correct);
  //     bodyFormData.set("html", resultObj.html);
  //     bodyFormData.set("ans", resultObj.q_ans);
  //     bodyFormData.set("length", resultObj.length);

  //     t = 4;
  //   }

  //   submitQuestionResponse(bodyFormData) // FIXED: Removed "const"
  //     .then((data) => {
  //       if (data.response) {
  //         if (
  //           data.response.status === 403 &&
  //           data.response.data.message === "Tokens finished" &&
  //           data.response.data.tokens === 0
  //         ) {
  //           updateState({
  //             currTokens: data.response.data.tokens,
  //             loader: false,
  //           });
  //           togglePopUp(true);
  //           return true;
  //         }
  //       }

  //       updateState({
  //         // FIXED: Removed callback
  //         resultPopup: true,
  //       });

  //       const { user, tokens } = data.data;
  //       const questionSubCat = state.questionData[0].subcategory_id;
  //       const token = speaking.includes(questionSubCat)
  //         ? tokens.speaking
  //         : writing.includes(questionSubCat)
  //         ? tokens.writing
  //         : null;

  //       const { score_data } = data.data.data;

  //       if ([11, 12].includes(parseInt(resultObj.type))) {
  //         getOpenAIExplaination(bodyFormData);
  //       }

  //       if (user) {
  //         store.dispatch(setUser(user));
  //         loadAttemptedQuestiondata(state.questionData[0].id);
  //       }

  //       let state_obj = {
  //         loader: false,
  //         user,
  //         historyData: score_data,
  //         process: false,
  //         user_text: null,
  //         currTokens: token,
  //         tokens,
  //       };

  //       switch (t) {
  //         case 1:
  //           afterSubmitResponseActionOne(data.data, state_obj);
  //           break;
  //         case 2:
  //           if (questionData[0].subcategory_id === 7) {
  //             essayResponse(data.data, state_obj); // You need to implement this function
  //           } else {
  //             afterSubmitResponseActionTwo(data.data, state_obj);
  //           }
  //           break;
  //         case 3:
  //           afterSubmitResponseActionThree(data.data, state_obj);
  //           break;
  //         case 4:
  //           afterSubmitResponseActionFour(data.data, state_obj);
  //           break;
  //         default:
  //           console.log("its default");
  //       }
  //     })
  //     .catch((err) => {
  //       updateState({
  //         process: false,
  //         user_text: "request failed. try again",
  //         is_answer: false,
  //       });
  //       store.dispatch(
  //         setAlert({
  //           flag: true,
  //           type: 2,
  //           message: "Something went wrong.",
  //         })
  //       );
  //     });
  // };
    const getOpenAIExplaination = async (formData) => {
    API({
      method: "POST",
      url: `submit-explanation`,
      data: formData,
    }).then((res) => {
      updateState({
        option_explaination: res.data,
      });
    });
  };

  const showResponse = useCallback(async () => {
  if (state.intervalId1) {
    clearInterval(state.intervalId1);
    updateState({ intervalId1: null });
  }
  
  updateState({
    is_answer: true,
    resultData: "",
    process: true,
    loader: true,
    mainAudioPlaying: false,
    new_result: null,
    attemptedTimes: state.attemptedTimes + 1,
    isStopped: false
  });

  const currentState = state;
  if (currentState.intervalId1) {
    clearInterval(currentState.intervalId1);
  }

  const { questionData, resultObj } = currentState;
  if (!questionData || questionData.length === 0 || !resultObj) {
    updateState({
      process: false,
      loader: false,
      user_text: "Invalid data, please try again",
    });
    return;
  }

  const bodyFormData = new FormData();
  bodyFormData.set("text", resultObj.answer || "");
  bodyFormData.set("script", resultObj.script || "");
  bodyFormData.set("type", resultObj.type || "");
  bodyFormData.set("id", resultObj.id || "");
  bodyFormData.set("lang", resultObj.lang || "");
  bodyFormData.set("practice", "1");
  bodyFormData.set("device", "website");

  // Add other form data based on question type
  const subcategoryId = questionData[0]?.subcategory_id;
  let responseType = 0;

  if ([1, 2, 3, 4, 5, 21, 22].includes(subcategoryId)) {
    bodyFormData.set("answer", resultObj.ans || "");
    bodyFormData.set("text_answer", resultObj.text_answer || "");
    bodyFormData.set("q_ans", resultObj.q_ans || "");
    bodyFormData.set("length", resultObj.length || "");

    if (resultObj.data && resultObj.data !== "") {
      bodyFormData.set("file", resultObj.data);
    }
    if (resultObj.duration && resultObj.duration !== "") {
      bodyFormData.set("duration", resultObj.duration);
    }

    bodyFormData.set("audio_text", resultObj.audio_text || "");
    if (parseInt(subcategoryId) === 1) {
      bodyFormData.set("strategy", resultObj.strategy || "");
    }
    responseType = 1;
  } else if ([6, 7].includes(subcategoryId)) {
    bodyFormData.set("answer", resultObj.q_ans || "");
    bodyFormData.set("text_answer", resultObj.text_answer || "");
    bodyFormData.set("length", resultObj.length || "");
    responseType = 2;
  } else if ([8, 9, 10, 11, 12].includes(subcategoryId)) {
    bodyFormData.set("selected", resultObj.text_answer || "");
    bodyFormData.set("answer", resultObj.correct || "");
    bodyFormData.set("correct", resultObj.correct || "");
    responseType = 3;
  } else if ([13, 14, 15, 17, 19, 20, 18, 16].includes(subcategoryId)) {
    bodyFormData.set("text_answer", resultObj.text_answer || "");
    bodyFormData.set("answer", resultObj.correct || "");
    bodyFormData.set("selected", resultObj.text_answer || "");
    bodyFormData.set("correct", resultObj.correct || "");
    bodyFormData.set("html", resultObj.html || "");
    bodyFormData.set("ans", resultObj.q_ans || "");
    bodyFormData.set("length", resultObj.length || "");
    responseType = 4;
  }

  try {
    const data = await submitQuestionResponse(bodyFormData);

    if (
      data?.response?.status === 403 &&
      data?.response?.data?.message === "Tokens finished"
    ) {
      updateState({
        currTokens: 0,
        loader: false,
        process: false,
        is_answer: false,
        tokensPopUp: true,
      });
      return;
    }

    updateState({
      resultPopup: true,
      loader: false,
      process: false,
    });

    const user = data?.data?.user;
    const tokens = data?.data?.tokens;
    const questionSubCat = questionData[0]?.subcategory_id;
    const token = speaking.includes(questionSubCat)
      ? tokens?.speaking
      : writing.includes(questionSubCat)
      ? tokens?.writing
      : null;

    if (user) {
      props.setUser(user);
      loadAttemptedQuestiondata(currentState.questionData[0].id);
    }

    const state_obj = {
      loader: false,
      historyData: data?.data?.data?.score_data || [],
      process: false,
      user_text: null,
      currTokens: token,
      tokens,
    };

    // Handle different response types
    switch (responseType) {
      case 1:
        afterSubmitResponseActionOne(data?.data, state_obj);
        break;
      case 2:
        if (questionData[0]?.subcategory_id === 7) {
          essayResponse(data?.data, state_obj);
        } else {
          afterSubmitResponseActionTwo(data?.data, state_obj);
        }
        break;
      case 3:
        afterSubmitResponseActionThree(data?.data, state_obj);
        break;
      case 4:
        afterSubmitResponseActionFour(data?.data, state_obj);
        break;
      default:
        console.warn("Unhandled response type:", responseType);
        updateState({
          ...state_obj,
          new_result: data?.data?.new_format || null,
        });
    }

    // Fetch explanations for specific subcategories
    if ([11, 12].includes(parseInt(resultObj.type))) {
      getOpenAIExplaination(bodyFormData);
    }
  } catch (err) {
     if (err?.response?.status === 403 && 
      err?.response?.data?.message === "Tokens finished") {
    updateState({
      currTokens: 0,
      loader: false,
      process: false,
      is_answer: false,
      tokensPopUp: true,
    });
    return;
  }
    console.error(err);
    updateState({
      process: false,
      user_text: "Request failed. Try again",
      is_answer: false,
      loader: false,
    });
    store.dispatch(
      setAlert({
        flag: true,
        type: 2,
        message: "Something went wrong.",
      })
    );
  }
}, [
  state,
  submitQuestionResponse,
  props,
  loadAttemptedQuestiondata,
  afterSubmitResponseActionOne,
  afterSubmitResponseActionTwo,
  afterSubmitResponseActionThree,
  afterSubmitResponseActionFour,
  essayResponse,
  getOpenAIExplaination,
  updateState
]);


  const explanationPopUp = (status) => {
    updateState({ explanationPopUp: status });
  };

  const togglePopUp = (status) => {
    updateState({ tokensPopUp: status });
  };

  // useEffect(() => {
  //   if (props.expVidPopup === 10 && !state.nextBtnVid) {
  //     nextButton(true);
  //   }
  // }, [props.expVidPopup]);



  const resultStatus = () => {
    updateState({ is_result: true });
  };

  const showHistory = (e) => {
    e.preventDefault();
    updateState({
      boardMore: false,
      history_flag: true,
      note_flag: false,
      comment_flag: false,
      board_flag: false,
      history_process: false,
    });
  };

  const showBoard = (e) => {
    e.preventDefault();
    updateState({
      historyMore: false,
      note_flag: false,
      history_flag: false,
      board_flag: true,
      comment_flag: false,
      board_process: false,
    });
  };

  const showNotes = (e) => {
    e.preventDefault();
    updateState({
      historyMore: false,
      history_flag: false,
      board_flag: false,
      note_flag: true,
      comment_flag: false,
      board_process: false,
    });
  };

  const showComment = (e) => {
    e.preventDefault();
    updateState({
      comment_flag: true,
      history_flag: false,
      board_flag: false,
      note_flag: false,
      comment_process: false,
    });
  };

  const changeResponseArr = (data) => {
    updateState({ history: data });
  };

  const testedFunc = () => {
    updateState({ testModal: true });
  };

 const toggleSwitch = (checked) => {
  updateState({ switched: checked });
};

  const testedNo = () => {
    updateState({ testModal: false });
  };

  const testedYes = () => {
    var bodyFormData = new FormData();
    bodyFormData.set("question_id", state.questionData[0].id);
    API({
      method: "POST",
      url: "tested/exam",
      data: bodyFormData,
    }).then((data) => {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: data.data.message })
      );
      updateState({ testModal: false, testCount: data.data.count });
    });
    updateState({ testModal: false });
    forceUpdate();
  };

  const timer1 = useCallback(() => {
    // setState((prevState) => ({
    //   ...prevState,
    //   secondCount1: prevState.secondCount1 + 1,
    // }));
  }, []);

  // const restartQuestion = () => {
  //   updateState({
  //     restart: true,
  //     is_result: false,
  //     is_answer: false,
  //     secondCount1: 0,
  //     user_text: null,
  //     fail: undefined,
  //     new_html: null,
  //     option_explaination: "",
  //     confirmRestart: false,
  //   });
  //   forceUpdate();
  // };

  // const showVideoModal = () => {
  //   if (state.videoUrl) {
  //     updateState({ videoModal: true });
  //     updateState({ videoModalState: true });
  //   } else {
  //     updateState({ showBottomExplanationPopup: true });
  //   }
  // };
  
  const restartQuestion = useCallback(() => {
  updateState((prev) => {
    // Prevent multiple clicks
    if (prev.confirmRestartProcessing) return {};

    if (prev.intervalId1) {
      clearInterval(prev.intervalId1);
    }

    return {
      confirmRestartProcessing: true,
      confirmRestart: false,
      restart: true,
      secondCount1: 0,
      intervalId1: null,
      is_result: false,
      is_answer: false,
      user_text: null,
      fail: undefined,
      new_html: null,
      submitFlag: false,
      option_explaination: "",
      mainAudioPlaying: true,
      isStopped: false,
      switched: false,
      soundStatusMain: true,
      playingAudioFromTrascriptButton: false,
    };
  });

  // Unlock after state settles
  setTimeout(() => {
    updateState({ confirmRestartProcessing: false });
  }, 300);
}, [updateState]);

  
  const showVideoModal = () => {
    if (state.videoUrl && state.videoUrl !== "null") {
      updateState({ videoModal: true, videoModalState: true });
    } else {
      updateState({ showBottomExplanationPopup: true });
    }
  };

  const showHindiVideoModal = () => {
    if (state.videoHindiUrl && state.videoHindiUrl !== "null") {
      updateState({ videoHindiModal: true, videoHindiModalState: true });
    } else {
      updateState({ showBottomExplanationPopup: true });
    }
  };

  const closeVideoModal = () => {
    updateState({ videoModal: false });
    // updateState({videoModalState:false});
  };

  const closeHindiVideoModal = () => {
    updateState({ videoHindiModal: false });
    // updateState({videoModalState:false});
  };



  const changeInput = (e) => {
    let { name, value } = e.target;
    var bodyFormData = new FormData();
    bodyFormData.set("question_id", state.questionData[0].id);
    bodyFormData.set("tag", value);

    bodyFormData.set("id", state.type);
    bodyFormData.set("prediction", state.prediction);
    bodyFormData.set("type", state.aType);
    bodyFormData.set("mark", state.mark);
    API({
      method: "POST",
      url: "set/tag",
      data: bodyFormData,
    }).then((data) => {
      let items = state.questionData;

      //var foundIndex = items.findIndex(x => x.id == item.id);
      items[0] = { ...state.questionData[0], tag: [{ tag: value }] };
      updateState({ questionData: items });
      //updateState({'questionData':data.data.result.data});
      //loadQuestiondata();
      //store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
      //updateState({testModal:false, testCount:data.data.count});
    });
    updateState({ [name]: value });
  };

  const soundChecked = () => {};
  const stopRecording = () => {};

  const setStrategy = (st) => {
    const r = state.resultObj;
    r.strategy = st;
    updateState({
      resultObj: r,
    });
  };

  const renderResponse = (items) => {
    return (
      <>
        {items.map((item, i) => {
          if (state.questionData[0].subcategory_id === 5) {
            return (
              <>
                <span>Your Response: </span>
                <span className={item.class} key={i}>
                  {item.word !== "&nbsp;" ? item.word : " "}
                </span>
              </>
            );
          } else {
            {
              /*return <span className={item.class} key={i}>{item.word !== "&nbsp;" ? item.word : " "}</span>;*/
            }
            return <TooltipItem key={i} item={item} id={i} />;
          }
        })}
      </>
    );
  };

  const wordDefinitionModalToggle = (status) => {
    if (status) {
      updateState({
        modalDestroy: false,
        wordDefinitionModalIsOpen: status,
      });
    } else {
      updateState({
        wordDefinitionModalIsOpen: status,
      });

      setTimeout(() => {
        updateState({
          modalDestroy: true,
          selectedWord: "",
        });
      }, 1000);
    }
  };

  const selectWord = (item) => {
    wordDefinitionModalToggle(true);

    updateState({
      selectedWord: item,
    });
  };

  const translatePopup = (status) => {
    updateState({
      shadowingPopup: status,
      translateModal: status,
    });
  };

  const sampleResponseAudioPopup = (status) => {
    updateState({
      shadowingPopup: status,
      sampleResponseModal: status,
    });
  };

  const filterScript = (question) => {
    let script = "";
    let q = question.split("__add_blank__");
    q.map((item, i) => {
      if (i === 0) {
        script += item;
      } else {
        let raw = item;
        item = item.replace("<span id='cAns'>", "");
        let word = item.split("</span>")[0];
        item = item.replace(`${word}</span>`, word);
        // console.log(item);
        script += item;
      }
    });

    return script;
  };

  const questionScript = () => {
    let script = "";
    switch (state.questionData[0].subcategory_id) {
      case 1:
        script = state.questionData[0].question;
        break;
      case 2:
        script = state.questionData[0].audio_script;
        break;
      case 4:
        script = state.questionData[0].audio_script;
        break;
      case 11:
        script = filterScript(state.questionData[0].question);
        break;
      case 13:
        script = state.questionData[0].audio_script;
        break;
      case 16:
        script = state.questionData[0].audio_script;
        break;
    }
    return script;
  };

  const toggleResultPopup = () => {
    updateState({
      resultPopup: !state.resultPopup,
    });
  };

  const writeEssayAiSuggestions = (question) => {
    let status = false;
    if (question !== undefined && parseInt(question.subcategory_id) === 7) {
      status = true;
    }

    return status;
  };

  const setCorrectClassName = () => {
    let className = "";
    const subcategory_id = parseInt(state.type);

    if ([8, 9].includes(subcategory_id)) {
      className = "reading-section";
    } else if ([10].includes(subcategory_id)) {
      className = "re-order-section";
    } else if ([13].includes(subcategory_id)) {
      className = "write-essay-wrapper";
    } else if ([16].includes(subcategory_id)) {
      className = "lf-blank";
    }

    return className;
  };

  const restartConfirmationToggle = () => {
    const { confirmRestart } = state;

    updateState({
      confirmRestart: !confirmRestart,
    });
  };

  const updateAudioFinishedFromTranscript = (status) => {
    updateState({
      playingAudioFromTrascriptButton: status,
    });
  };

  const buttonLabel = (subcategory_id) => {
    if (subcategory_id === 1) {
      return "Sample Response";
    } else {
      return "Hearing Mode";
    }
    return "";
  };



  // const showPreviousButton = () => {
  //   const { questionsList, currentQues } = state;

  //   let button = "";
  //   if (questionsList.findIndex((obj) => obj.index === currentQues) !== 0) {
  //     button = (
  //       <button
  //         type="button"
  //         onClick={prevButton}
  //         className="prev-next-btn visibility-visible"
  //       >
  //         Previous
  //       </button>
  //     );
  //   }

  //   return button;
  // };

  // const showNextButton = () => {
  //   const { questionsList, currentQues } = state;

  //   let button = "";
  //   if (
  //     questionsList.findIndex((obj) => obj.index === currentQues) !==
  //     questionsList.length - 1
  //   ) {
  //     button = (
  //       <button
  //         type="button"
  //         onClick={() => nextButton(false)}
  //         className="prev-next-btn visibility-visible"
  //       >
  //         Next
  //       </button>
  //     );
  //   }

  //   return button;
  // };
  
  const showPreviousButton = useCallback(() => {
  const { questionsList, currentQues, prevButtonLoading, nextButtonLoading } = state;
  
  const currentIndex = questionsList.findIndex(
    (obj) => obj.index === currentQues
  );
  
  if (currentIndex === 0) return null;

  return (
    <button
      onClick={prevButton}
      disabled={prevButtonLoading || nextButtonLoading}
      className={`prev-next-btn ${
        prevButtonLoading || nextButtonLoading ? "disabled" : ""
      }`}
    >
      {prevButtonLoading ? "Loading..." : "Previous"}
    </button>
  );
}, [state.questionsList, state.currentQues, state.prevButtonLoading, state.nextButtonLoading, prevButton]);

const showNextButton = useCallback(() => {
  const { questionsList, currentQues, nextButtonLoading, prevButtonLoading } = state;
  
  const currentIndex = questionsList.findIndex(
    (obj) => obj.index === currentQues
  );
  
  if (currentIndex === questionsList.length - 1) return null;

  return (
    <button
      onClick={() => nextButton(false)}
      disabled={nextButtonLoading || prevButtonLoading}
      className={`prev-next-btn ${
        nextButtonLoading || prevButtonLoading ? "disabled" : ""
      }`}
    >
      {nextButtonLoading ? "Loading..." : "Next"}
    </button>
  );
}, [state.questionsList, state.currentQues, state.nextButtonLoading, state.prevButtonLoading, nextButton]);

  let que;
  let ques_title = "";
  let title;
  let topBar = false;

  let {
    questionData,
    currentQuestion,
    type,
    all_ok,
    modal,
    reportText,
    testModal,
    videoModal,
    videoModalState,
    videoUrl,
    videoHindiModal,
    videoHindiModalState,
    videoHindiUrl,
    is_answer,
    tag,
    timeDiffInMs,
    thirtyDaysInMs,
    isAttempted,
    secondCount1,
    hideNav,
    total_questions,
    isBlocked,
    resultData,
    historyData,
    resultId,
    switched,
    isSubscribed,
    user,
    submitFlag,
    viewVideo,
    viewHindiVideo,
    testCount,
    comment_flag,
    isSubscribedCheck,
    history_flag,
    board_flag,
    note_flag,
    open_ques,
    restart,
    user_text,
    fail,
    content_score,
    pronunciation_score,
    fluency_score,
    intonation_score,
    average_pace,
    total_score,
    writing_result,
    new_result,
    option_explaination,
    resultObj,
    template_type,
    template_issue,
    common_sentence,
    score_data,
    no_of_repeat_allowed,
    allData,
    showBottomExplanationPopup,
    tokensPopUp,
  } = state;

  // console.log("These are the states : ",state);

  const templateDetectorModalProps = {
    title:
      template_type === "repeat"
        ? template_issue
        : template_type === "common"
        ? common_sentence
        : "",
    template_type: template_type,
    common_sentence: common_sentence,
    // data: {
    //   remarks: score_data[0]?.remarks,
    //   no_of_repeat_allowed: no_of_repeat_allowed,
    //   overallScore: allData?.pronunciation ,
    //   contentScore: allData?.content ,
    //   fluencyScore: allData?.fluency ,
    //   pronunciationScore: allData?.pronunciation,
    // },
  };

  let questionprops = {
    restart,
    restartQue: restartQue,
    submit: submitResponse,
    showResult: resultStatus,
    data: questionData[0],
    // func: changeAnswer,
    answer: is_answer,
    resultMode: false,
    testCount: 0,
    tag: "grey",
    testMode: false,
    resultId: false,
    soundChecked: soundChecked,
    stopRecording: stopRecording,
    user_text,
    strategy: state.resultObj.strategy,
    setStrategy: setStrategy,
    setRestart: setRestart,
    scriptLanguages: state.scriptLanguages,
    voices: state.voices,
    shadowingPopup: state.shadowingPopup,
    total_questions,
    currentQuestion,
    showResponse: showResponse,
    updateQuestionAudioUrlInPractice: updateQuestionAudioUrl,
    setIsStopped,
    soundStatusMain: state.soundStatusMain,
  onMainAudioFinished: () => {
    updateState({ mainAudioPlaying: false });
  },
  isStopped: state.isStopped
  };

  if (Array.isArray(questionData) && questionData.length > 0) {
    ques_title = questionData[0].q_title;
  }

  switch (type) {
    case "1":
      que = (
        <ReadAloud
          languages={state.scriptLanguages}
          {...questionprops}
          key={restart || currentQuestion}
        />
      );
      title =
        "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
      break;
    case "2":
      que = (
        <RepeatSentece {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
      break;
    case "3":
      que = (
        <DescribeImage {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "Look at the Image below. In 25 seconds, please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
      break;
    case "4":
      que = <RetellLec {...questionprops} key={restart || currentQuestion} />;
      title =
        "Listen to and read a description of a situation. You will have 20 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
      break;
    case "5":
      que = <ShortQue {...questionprops} key={restart || currentQuestion} />;
      title =
        "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
      break;
    case "6":
      que = <Summary {...questionprops} key={restart || currentQuestion} />;
      title =
        "Read the passage below. Summarize the passage using between 25 and 50 words. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
      break;
    case "7":
      que = <Essay {...questionprops} key={restart || currentQuestion} />;
      title =
        "Read a description of a situation. Then write an email about the situation. You will have 9 minutes. You should aim to write at least 100 words.";
      break;
    case "8":
      topBar = true;
      que = (
        <SingleAnswer {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case "9":
      topBar = true;
      que = (
        <MultipleAnswer {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
      break;
    case "10":
      que = <Reorder {...questionprops} key={restart || currentQuestion} />;
      title =
        "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
      break;
    case "11":
      topBar = true;
      que = (
        <ReadingBlank
          {...questionprops}
          languages={state.scriptLanguages}
          option_explaination={option_explaination}
          key={restart || currentQuestion}
        />
      );
      title =
        "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
      break;
    case "12":
      topBar = true;
      que = (
        <WrittingBlank
          {...questionprops}
          languages={state.scriptLanguages}
          option_explaination={state.option_explaination}
          key={restart || currentQuestion}
        />
      );
      title =
        "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
      break;
    case "13":
      que = <Summer {...questionprops} key={restart || currentQuestion} />;
      title =
        "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 20-30 words. You have 8 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
      break;
    case "14":
      topBar = true;
      que = <McqSingle {...questionprops} key={restart || currentQuestion} />;
      title =
        "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case "15":
      topBar = true;
      que = <McqMulti {...questionprops} key={restart || currentQuestion} />;
      title =
        "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
      break;
    case "16":
      topBar = true;
      que = (
        <ListeningBlank {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "You will hear a recording. Type the missing words in each blank.";
      break;
    case "17":
      topBar = true;
      que = (
        <CorrectSummary {...questionprops} key={restart || currentQuestion} />
      );
      title =
        "You will hear a recording. Click on the paragraph that best relates to the recording.";
      break;
    case "18":
      topBar = true;
      que = <MissingWord {...questionprops} key={restart || currentQuestion} />;
      title =
        "You will hear a recording about " +
        ques_title +
        ". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
      break;
    case "19":
      topBar = true;
      que = <Highlight {...questionprops} key={restart || currentQuestion} />;
      title =
        "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
      break;
    case "20":
      que = <Dictation {...questionprops} key={restart || currentQuestion} />;
      title =
        "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
      break;
      //  case "22":
      // que = <SummarizeGroupDiscussion {...questionprops} key={restart || currentQuestion} />;
      // title =
      //   "You will hear three people having a discussion. When you hear the beep, summarize the whole discussion. You will have 10 seconds to prepare and 2 minutes to give your response.";
      // break;
      //  case "21":
      // que = <RespondToSituation {...questionprops} key={restart || currentQuestion} />;
      // title =
      //   "Listen to and read a description of a situation. You will have 10 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
      // break;
    default:
    // code block
  }

  let content_class_name = "";
  if (content_score !== undefined) {
    if (parseInt(type) !== 5) {
      content_class_name =
        content_score.score <= 30
          ? "text-danger"
          : content_score.score > 30 && content_score.score <= 70
          ? "text-orange"
          : "text-success";
    } else {
      content_class_name =
        content_score.score < 1 ? "text-danger" : "text-success";
    }
  }

  let speak_result_show = false;
  let write_result_show = false;
  let reading_result_show = false;
  let listening_result_show = false;

  if ([1, 2, 3, 4, 5, 21, 22].includes(parseInt(type))) {
    speak_result_show = new_result !== null ? true : false; // also for type 20.
  }

  if ([6, 7, 13, 20].includes(parseInt(type))) {
    write_result_show =
      new_result !== null ? true : new_result !== null ? true : false; // also for type 13.
  }

  if ([8, 9, 10, 11, 12].includes(parseInt(type)) && new_result !== null) {
    reading_result_show = true;
  }

  if (
    [14, 15, 16, 17, 18, 19].includes(parseInt(type)) &&
    new_result !== null
  ) {
    listening_result_show = true;
  }
  if (state.loading) {
  return <LoaderDumb show={true} />;
}
  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>

      {!all_ok && <ChromeCheck />}

      {!state.connected && (
        <div className="connectivity-container">
          <div className="bg-danger text-light not-connected text-center p-1">
            Seems like you are not connected to our server. Please try reloading
            the page or check your connection. &nbsp;{" "}
            <button className="btn-success btn-sm">Connect</button>
          </div>
        </div>
      )}

      {state.connected && state.backOnline && (
        <div className="connectivity-container">
          <div className="bg-success text-light not-connected text-center p-1">
            <b>Connection restored. Please continue with your tasks.</b>
          </div>
        </div>
      )}

      {all_ok && questionData.length > 0 && (
        <>
          {state.questionAudioUrl && (
            <QuestionAudioAlternative
              question_audio={state.questionAudioUrl}
              play={state.playingAudioFromTrascriptButton}
              refreshHistory={state.refreshHistory}
              updateAudioFinishedFromTranscript={
                updateAudioFinishedFromTranscript
              }
            />
          )}

          {state.resultPopup && SHOW_RESULT_POPUP.includes(parseInt(type)) && (
            <ResultPopup
              question_id={questionData[0].id}
              isAnswer={is_answer}
              resultData={resultData}
              speakingResult={speak_result_show}
              writingResult={write_result_show}
              readingResult={reading_result_show}
              listeningResult={listening_result_show}
              fail={fail}
              newResult={new_result}
              newHtml={state.new_html}
              subcategoryId={parseInt(type)}
              renderResponse={renderResponse}
              correctAnswer={questionData[0].answer}
              option_explaination={option_explaination}
              historyData={historyData}
              toggleResultPopup={toggleResultPopup}
              isPopup={false}
              question_title={questionData[0].q_title}
              recorded_file={resultObj.blob_url}
              template_issue={state.template_issue}
              template_type={state.template_type}
              common_sentence={state.common_sentence}
              score={state.score}
              explanationModal={state.explanationModal}
              templateDetectorModalProps={templateDetectorModalProps}
              // closeModalExplanation={closeModalExplanation}
            />
          )}

          <ConfirmAction
            title="Restart Question?"
            message={"Are your sure to restart this question?"}
            yesLabel="Yes, Please Restart"
            noLabel="No, I don't want to restart"
            status={state.confirmRestart}
            toggle={restartConfirmationToggle}
            confirm={restartQuestion}
          />

          <div className="siteContent p-0">
            <DashboardHeader title="Practice Material" />

            <div className={`pmw ${setCorrectClassName()}`}>
              <div className="dashboard-content-wrapper read-aloud-wrapper mb-12 new-dash">
                <PracticePageHeader
                  questionData={questionData[0]}
                  isAttempted={isAttempted}
                  TAGS={TAGS}
                  toggle={toggleDropDown}
                  isOpen={state.dropdownOpen}
                  changeHandler={changeInput}
                  time={secondCount1}
                  subcategoryId={type}
                  title={title}
                  strategyVideo={explanationPopUp}
                />
              </div>

              {type === "4" && (
                <div className="m-0 m-lg-0 pt-2 question-area-main">
                  <div className="pmw-outer-wrapper gray-text">
                    {questionData[0]?.audio_script}
                  </div>
                </div>
              )}

              {/* <div className="question-area-main">{que}</div> */}
              <div className="question-area-main">
  {state.retryError === true ? (
    <div className="retry-container d-flex flex-column align-items-center justify-content-center">
      <p className="error-text">{state.retryMessage}</p>
      <button className="outline-btn" onClick={() => retryQuestion()}>
        Retry
      </button>
    </div>
  ) : questionData.length > 0 && state.isNavigatingToNextQue === false ? (
    que
  ) : (
    <div className="pmw-tabs-section pmw-outer-wrapper m-0 loading-wrapper">
      <div className="question-skeleton">
        <Spinner id="mocklist-spinner-question" />
      </div>
    </div>
  )}
</div>

              {!SHOW_RESULT_POPUP.includes(parseInt(type)) && (
                <Result
                  isAnswer={is_answer}
                  resultData={resultData}
                  speakingResult={speak_result_show}
                  writingResult={write_result_show}
                  readingResult={reading_result_show}
                  listeningResult={listening_result_show}
                  fail={fail}
                  newResult={new_result}
                  newHtml={state.new_html}
                  subcategoryId={parseInt(type)}
                  renderResponse={renderResponse}
                  correctAnswer={questionData[0].answer}
                  option_explaination={option_explaination}
                  historyData={historyData}
                  recorded_file={state.blobURL}
                />
              )}

              <div className="pmw-outer-wrapper audio-transcript-wrapper">
                <div className="d-flex align-items-center justify-content-between flex-wrap lg:flex-wrap">
                  <div className="left-btns audio-transcript-content">
                    <button
                      type="button"
                      className="outline-btn"
                      onClick={restartConfirmationToggle}
                      disabled={state.retryError}
                    >
                      Restart
                    </button>

                    <button
                      type="button"
                      className="submit-btns"
                      onClick={showResponse}
                      disabled={is_answer || (!submitFlag && !state.isStopped)}
                    >
                      Submit
                    </button>

                    {viewVideo && (
                      <button
                        type="button"
                        className="outline-btn ml-3"
                        onClick={showVideoModal}
                      >
                        Explanation (English)
                      </button>
                    )}

                    {AUDIO_TRANSCRIPT.includes(
                      questionData[0].subcategory_id
                    ) && (
                      <span className="audio_script_button">
                        Audio Transcript:{" "}
                        {/* <Switch
                          onText="Show"
                          offText="Hide"
                          onChange={(el, state) => toggleSwitch(el, state)}
                          on={switched}
                          value={switched}
                        ></Switch> */}
                         <Form.Check 
    type="switch"
    id="audio-transcript-switch"
    checked={switched}
    onChange={(e) => toggleSwitch(e.target.checked)}
  />
                      </span>
                    )}

                    {/* Write Essay Ai Buttons */}
                    {writeEssayAiSuggestions(questionData[0]) && (
                      <MoreAiSuggestions
                        question_id={state.questionData[0].id}
                      />
                    )}

                    {SHOW_RESULT_POPUP.includes(parseInt(type)) &&
                      is_answer && (
                        <button
                          type="button"
                          className="submit-btns"
                          onClick={toggleResultPopup}
                        >
                          See Result
                        </button>
                      )}
                  </div>

                  <div className="right-btns">
                    {state.questionsList.length > 1 && (
                      <>
                        {showPreviousButton()}

                        {showNextButton()}
                      </>
                    )}
                  </div>
                </div>

                {switched && (
                  <>
                    <div className="audio-transcript-text visibility-visible line-height-adjust">
                      {questionData[0].audio_script !== null &&
                        questionData[0].audio_script
                          .split(" ")
                          .map((item, i) => {
                            return (
                              <React.Fragment key={i}>
                                <span
                                  className="word cursor-default"
                                  onClick={() => selectWord(item)}
                                >
                                  {item}
                                </span>
                                <i> </i>
                              </React.Fragment>
                            );
                          })}
                      <span
                        className="outline-btn cursor-pointer"
                        onClick={() => {
                          if (!state.mainAudioPlaying) {
          updateAudioFinishedFromTranscript(!state.playingAudioFromTrascriptButton);

        }
                        }
                          // updateAudioFinishedFromTranscript(
                          //   !state.playingAudioFromTrascriptButton
                          // )
                        }
                         style={{ 
        opacity: state.mainAudioPlaying ? 0.5 : 1, 
        cursor: state.mainAudioPlaying ? 'not-allowed' : 'pointer' 
      }}
                      >
                        {!state.playingAudioFromTrascriptButton ? (
                          <>
                            <i className="fa fa-play"></i>
                          </>
                        ) : (
                          <>
                            <i className="fa fa-stop"></i>
                          </>
                        )}
                      </span>
                      {parseInt(type) === 5 && (
                        <div>
                          Correct Answer:{" "}
                          <span className="correct-answer">
                            {questionData[0].answer}
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div className="pmw-outline-btns pmw-outer-wrapper d-flex align-items-center justify-content-between ">
                <div className="outline-left-btns">
                  {/* {TRANSLATE_BUTTON_SUBCATEGORIES.includes(
                    questionData[0].subcategory_id
                  ) && (
                    <button
                      type="button"
                      className="outline-btn"
                      onClick={() => translatePopup(true)}
                      disabled={state.retryError}
                    >
                      Translate
                    </button>
                  )} */}
                  {SAMPLE_RESPONSE_BUTTON_SUBCATEGORIES.includes(
                    questionData[0].subcategory_id
                  ) && (
                    <button
                      type="button"
                      className="outline-btn"
                      onClick={() => sampleResponseAudioPopup(true)}
                    >
                      {buttonLabel(questionData[0].subcategory_id)}
                    </button>
                  )}
                </div>

                <div className="outline-right-btns">
                  <button type="button" className="outline-btn">
                    {questionData[0].attempted.length} X Attempted
                  </button>
                  {/* <button
                    type="button"
                    className="outline-btn"
                    onClick={testedFunc}
                  >
                    {testCount} X Tested
                  </button> */}
                  <button
                    type="button"
                    onClick={showModal}
                    className="outline-btn"
                  >
                    Report
                  </button>
                </div>
              </div>

              {questionData.length !== 0 && !state.retryError && (
                <QuestionResponses
                  loadMyData={showHistory}
                  loadOthersData={showBoard}
                  questionData={questionData[0]}
                  key={restart || currentQuestion}
                   updateAttemptedState={updateAttemptedState}
    refreshHistory={state.refreshHistory}
                />
              )}
            </div>

            <ExplanationPopUp
              status={state.nextBtnVid}
              toggle={nextButtonVidPopup}
              isSubscribed={state.isSubscribed}
              expVid={state.expVid}
            />

            {showBottomExplanationPopup && (
              <ModalSkeleton
                status={showBottomExplanationPopup}
                toggle={() =>
                  updateState({ showBottomExplanationPopup: false })
                }
                handleClick={() => {
                  props.history.push("/admin/sub/payment/form/37");
                }}
                btnText="Buy Plan"
                message="Please subscribe to our gold plan to see Explanation Video"
                isSmall={false}
              />
            )}

            {state.translateModal && (
              <TranslateModal
                isOpen={state.shadowingPopup}
                toggle={translatePopup}
                question={questionScript()}
                languages={state.scriptLanguages}
                question_id={state.questionData[0].id}
                voices={state.voices}
              />
            )}

            {state.sampleResponseModal && (
              <ListenAudio
                isOpen={state.shadowingPopup}
                toggle={sampleResponseAudioPopup}
                question={questionScript()}
                question_id={state.questionData[0].id}
                voices={state.voices}
                audios={questionData[0].question_audios}
                subcategory_id={state.questionData[0].subcategory_id}
              />
            )}

            {state.explanationPopUp && (
              <ExplanationVidPopUp
                status={state.explanationPopUp}
                toggle={explanationPopUp}
                isSubscribed={state.isSubscribed}
                expVid={state.expVid}
              />
            )}

            {/* {state.wordDefinitionModalIsOpen && (
              <WordDefinitionModal
                isOpen={state.wordDefinitionModalIsOpen}
                toggle={wordDefinitionModalToggle}
                word={state.selectedWord}
                languages={state.scriptLanguages}
              />
            )} */}

            {tokensPopUp && (
              <TokenFinished isOpen={tokensPopUp} toggle={togglePopUp} />
            )}

            <LoaderDumb show={!state.loader} />
          </div>

          {modal && (
            <ReportPopup
              isOpen={modal}
              toggle={showModal}
              submit={submitReport}
              changeHandler={changeReportText}
              reportText={reportText}
            />
          )}

          {testModal && (
            <TestedPopup
              isOpen={testModal}
              toggle={testedNo}
              testedYes={testedYes}
            />
          )}

          {videoModal && (
            <QuestionExplanationVideo
              isOpen={state.videoModalState}
              toggle={closeVideoModal}
              videoUrl={videoUrl}
            />
          )}

          {videoHindiModal && (
            <Modal
              className="videopopup"
              centered="true"
              show={videoHindiModalState}
              size="lg"
            >
              <Modal.Body>
                <ReactPlayer url={videoHindiUrl} controls={true} />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="modalCloseBtn"
                  onClick={closeHindiVideoModal}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PracticeHistory);
